import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BlogLayout from './BlogLayout';
import { getPublishedPosts, formatPostDate } from '../utils/blog';

export default function BlogIndexPage() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    let active = true;
    getPublishedPosts().then((loaded) => {
      if (active) setPosts(loaded);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <BlogLayout>
      <main className="blog-index" aria-labelledby="blog-index-h">
        <header className="blog-index__head">
          <p className="landing-section-label">From the road ahead</p>
          <h1 id="blog-index-h" className="blog-index__title">
            Blog
          </h1>
          <div className="blog-trails" aria-hidden>
            <div className="lp-trail" style={{ width: 100 }} />
            <div className="lp-trail lp-trail--dim" style={{ width: 64 }} />
          </div>
        </header>

        {posts === null ? null : posts.length === 0 ? (
          <p className="blog-index__empty">New posts coming soon.</p>
        ) : (
          <div className="blog-index__list">
            {posts.map((post) => (
              <Link key={post.slug} to={`/blog/${post.slug}`} className="blog-row">
                <div className="blog-row__meta">
                  {post.date ? <span>{formatPostDate(post.date)}</span> : null}
                  {post.date && post.readTime ? (
                    <span className="blog-row__meta-sep" aria-hidden>
                      ·
                    </span>
                  ) : null}
                  {post.readTime ? <span>{post.readTime}</span> : null}
                </div>
                <h2 className="blog-row__title">{post.title}</h2>
                {post.excerpt ? <p className="blog-row__excerpt">{post.excerpt}</p> : null}
              </Link>
            ))}
          </div>
        )}
      </main>
    </BlogLayout>
  );
}
